// Toast/alert/modal mesajları için TR→EN map.
// Sık tekrarlanan onay, uyarı, başarı, hata mesajları için.
//
// Helper: translateMessage(msg, lang)

const MSG_TR_TO_EN = {
  // ── Toast Başarı ────────────────────────────────────────
  'Kaydedildi': 'Saved',
  'Başarıyla kaydedildi': 'Successfully saved',
  'Güncellendi': 'Updated',
  'Oluşturuldu': 'Created',
  'Silindi': 'Deleted',
  'Eklendi': 'Added',
  'Kopyalandı': 'Copied',
  'Yüklendi': 'Loaded',
  'Onaylandı': 'Approved',
  'Reddedildi': 'Rejected',
  'İptal edildi': 'Cancelled',
  'Tamamlandı': 'Completed',
  'Gönderildi': 'Sent',

  // ── Toast Hata ──────────────────────────────────────────
  'Hata': 'Error',
  'Bir hata oluştu': 'An error occurred',
  'İşlem başarısız': 'Operation failed',
  'Kayıt başarısız': 'Save failed',
  'Silme başarısız': 'Delete failed',
  'Güncelleme başarısız': 'Update failed',
  'Bağlantı hatası': 'Connection error',
  'Sunucu hatası': 'Server error',
  'Sunucuya bağlanılamadı': 'Could not connect to server',
  'Yetkiniz yok': 'Permission denied',
  'Bu işlem için yetkiniz yok': 'You do not have permission for this action',
  'Oturum süresi doldu': 'Session expired',
  'Geçersiz veri': 'Invalid data',
  'Zorunlu alanları doldurun': 'Please fill in required fields',
  'Lütfen tüm zorunlu alanları doldurun': 'Please fill in all required fields',
  'Geçersiz e-posta': 'Invalid email',
  'Geçersiz şifre': 'Invalid password',
  'Şifre en az 6 karakter olmalı': 'Password must be at least 6 characters',
  'E-posta veya şifre hatalı': 'Invalid email or password',

  // ── Confirm / Onay ─────────────────────────────────────
  'Silmek istediğinize emin misiniz?': 'Are you sure you want to delete?',
  'Bu kaydı silmek istediğinize emin misiniz?': 'Are you sure you want to delete this record?',
  'Emin misiniz?': 'Are you sure?',
  'Devam etmek istiyor musunuz?': 'Do you want to continue?',
  'Bu işlem geri alınamaz': 'This action cannot be undone',
  'Bu işlem geri alınamaz!': 'This action cannot be undone!',
  'Değişiklikleri kaydetmek istiyor musunuz?': 'Do you want to save changes?',
  'Değişiklikleri kaydetmeden çıkmak istiyor musunuz?': 'Discard unsaved changes?',

  // ── Bilgi / Uyarı ──────────────────────────────────────
  'Kayıt bulunamadı': 'No records found',
  'Sonuç yok': 'No results',
  'Veri yok': 'No data',
  'Yükleniyor...': 'Loading...',
  'Lütfen bekleyin...': 'Please wait...',
  'Kaydediliyor...': 'Saving...',
  'Siliniyor...': 'Deleting...',
  'Yükleniyor': 'Loading',
  'Hazırlanıyor...': 'Preparing...',
  'Gönderiliyor...': 'Sending...',
  'Önce müşteri seçin': 'Please select a customer first',
  'Önce depo seçin': 'Please select a warehouse first',
  'Önce kasa seçin': 'Please select a cash register first',
  'Önce şube seçin': 'Please select a branch first',
  'En az bir kalem girilmelidir': 'At least one line item is required',
  'Tutar 0\'dan büyük olmalı': 'Amount must be greater than 0',
  'Miktar 0\'dan büyük olmalı': 'Quantity must be greater than 0',
  'Stok seçilmedi': 'Stock not selected',
  'Cari seçilmedi': 'Account not selected',

  // ── Form / Field ───────────────────────────────────────
  'Bu alan zorunludur': 'This field is required',
  'Geçersiz format': 'Invalid format',
  'Sadece rakam girin': 'Numbers only',
  'En fazla {{max}} karakter': 'Maximum {{max}} characters',
  'En az {{min}} karakter': 'Minimum {{min}} characters',
};

export function translateMessage(msg, lang) {
  if (!msg) return msg;
  if ((lang || 'tr').startsWith('tr')) return msg;
  return MSG_TR_TO_EN[msg] || msg;
}

export default MSG_TR_TO_EN;
